import React, { useEffect, useState } from "react";
import "./contactUs.css";
import logo from "../../images/hkIstanbul2.png";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useForm } from "react-hook-form";
import { useLanguage } from "../LanguageContext/LanguageContext";

const WEB3FORMS_KEY_1 = "80941b77-57c1-4168-a4ea-53abbb9aad08"; // hk.istanbul.export@gmail.com
const WEB3FORMS_KEY_2 = "7dcafdfc-fcf8-4d92-8bd6-20ccf295a229"; // Info@hk-istanbul.com.tr

function ContactUs() {
  const { lang, t } = useLanguage();
  const [submitting, setSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ mode: "onSubmit", reValidateMode: "onChange" });

  useEffect(() => {
    document.querySelectorAll(".contactUsTextP").forEach((el) => {
      el.style.direction = lang === "ar" ? "rtl" : "ltr";
    });
  }, [lang]);

  const onSubmit = async (data) => {
    setSubmitting(true);
    const commonFields = {
      subject: `New Contact Request from ${data.name}`,
      from_name: data.name,
      replyto: data.email,
      "Name / Company": data.name,
      Email: data.email,
      "Request Type": data.requestType,
      Message: data.message,
    };

    try {
      const [res1, res2] = await Promise.all([
        fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ access_key: WEB3FORMS_KEY_1, ...commonFields }),
        }),
        fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ access_key: WEB3FORMS_KEY_2, ...commonFields }),
        }),
      ]);

      const [result1, result2] = await Promise.all([res1.json(), res2.json()]);

      if (result1.success && result2.success) {
        alert(lang === "ar" ? "تم إرسال رسالتك بنجاح!" : "Your message was sent successfully!");
        reset();
      } else {
        alert(lang === "ar" ? "حدث خطأ، يرجى المحاولة مرة أخرى." : "Something went wrong. Please try again.");
      }
    } catch {
      alert(lang === "ar" ? "حدث خطأ، يرجى المحاولة مرة أخرى." : "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="aboutUs">
      <div className="ContainerContactUsAndText">
        <div className="contactUsTextSection">
          <div>
            <img src={logo} alt="logo" />
          </div>
          <div className="contactUsText">
            <p className="contactUsTextP">{t.contactUs}</p>
          </div>
          <div className="icons">
            <a
              href="https://www.facebook.com/share/1F8VFxUMTd/?mibextid=wwXIfr"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookRoundedIcon style={{ width: "2em", height: "2em" }} />
            </a>
            <a
              href="https://www.instagram.com/hamdi_kargo?igsh=cGZrdGhxMHl2b3hr"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon style={{ width: "2em", height: "2em" }} />
            </a>
          </div>
          <div className="phonenumber">Call Us: +90 552 157 76 82</div>
          <div className="phonenumber">Mobile: +90 534 551 18 80</div>
          <div className="phonenumber">WHatsApp: +90 552 157 76 82</div>
          <div className="phonenumber">LandLine Phone: +90 212 225 24 20</div>
        </div>

        <div className="contactUsForm">
          <h1>{lang === "en" ? "Contact Us" : "تواصل معنا"}</h1>
          <div>
            <input
              id="name"
              type="text"
              placeholder={lang === "en" ? "Name / Company*" : "الشركة أو الأسم*"}
              className="input"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && <p className="errorp">{errors.name.message}</p>}
          </div>
          <div>
            <input
              placeholder={lang === "en" ? "Email*" : "البريد الالكتروني*"}
              className="input"
              type="email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address",
                },
              })}
            />
            {errors.email && <p className="errorp">{errors.email.message}</p>}
          </div>
          <div>
            <select
              className="selectRequest"
              {...register("requestType", { required: "Request type is required" })}
            >
              <option value="">
                {lang === "en" ? "Request Type*" : "طبيعة الطلب*"}
              </option>
              <option value="LCL/FCL">
                {lang === "en" ? "LCL / FCL" : "الشحن الجزئي / الشحن الكامل"}
              </option>
              <option value="General-Request">
                {lang === "en" ? "general Request" : "طلب عام"}
              </option>
            </select>
            {errors.requestType && (
              <p className="errorp">{errors.requestType.message}</p>
            )}
          </div>
          <div className="requestMessage">
            <textarea
              placeholder={lang === "en" ? "Request / massege" : "طلب / رسالة"}
              {...register("message", { required: "Message is required" })}
              name="message"
            />
            {errors.message && (
              <p className="errorp">{errors.message.message}</p>
            )}
          </div>
          <button className="submit" type="submit" disabled={submitting}>
            {submitting
              ? (lang === "ar" ? "جاري الإرسال..." : "Sending...")
              : (lang === "en" ? "Send" : "إرسال")}
          </button>
        </div>
      </div>
    </form>
  );
}

export default ContactUs;
